module.exports = __webpack_public_path__ + "img/CM-SL-CA-Infiniti-Playful.dd2569dc.jpeg";